import { React, variantProvider } from '@/app'
import { Button, Icon, Text, View, ProgressBar, HurdleLetterSquare } from '@/components'
import { RenderItemProps } from './types'
import { DebugItem } from './shared'
import { APIClient } from '@/services'
import { useIsFocusedFeedItem } from '../feedScroll'
import { formatHurdleDate, getHurdleProgressProps, locationPath, navigateToHurdle } from '@/utils'
import { TagType } from '../atoms/TagType'

// const words = [
//   {
//     word: ['P', 'L', 'A', 'N', 'E', 'T'],
//     match: ['not_in_word', 'wrong_position', 'not_in_word', 'not_in_word', 'wrong_position', 'not_in_word'],
//   },
//   {
//     word: ['E', 'T', 'H', 'I', 'C', 'S'],
//     match: ['wrong_position', 'not_in_word', 'wrong_position', 'not_in_word', 'not_in_word', 'not_in_word'],
//   },
//   {
//     word: ['H', 'E', 'R', 'B', 'A', 'L'],
//     match: ['correct', 'wrong_position', 'correct', 'not_in_word', 'not_in_word', 'wrong_position'],
//   },
//   {
//     word: ['H', 'U', 'M', 'B', 'L', 'E'],
//     match: ['correct', 'correct', 'not_in_word', 'not_in_word', 'correct', 'correct'],
//   },
//   {
//     word: ['H', 'U', 'R', 'D', 'L', 'E'],
//     match: ['correct', 'correct', 'correct', 'correct', 'correct', 'correct'],
//   },
//   {
//     word: [],
//     match: [],
//   },
// ]

// type LetterRowProps = {
//   row: (typeof words)[0]
// }

// const LetterRow = React.memo(({ row }: LetterRowProps) => {
//   return (
//     <View variants={['row']} style={styles.letterRow}>
//       {Array.from({ length: 6 }).map((_, idx) => (
//         <HurdleLetterSquare
//           key={idx}
//           idx={idx}
//           letter={row.word[idx] ?? ''}
//           isComplete={true}
//           match={(row.match[idx] ?? 'empty') as ''}
//         />
//       ))}
//     </View>
//   )
// })

export function FeedHurdle(props: RenderItemProps) {
  const { item, index } = props

  const isFocused = useIsFocusedFeedItem(index)

  const hurdleData = item?.hurdle_data

  const hurdleQuery = APIClient.Games.useHurdle(hurdleData?.id, {
    enabled: isFocused,
    placeholderData: hurdleData,
  })

  const hurdle = hurdleQuery.data

  const handleNavigateToHurdle = () => {
    locationPath.registerCurrentPath()
    navigateToHurdle()
    // segmentClient.track('hurdle_start')
  }

  return (
    <>
      <DebugItem {...props} />

      <View variants={['paddingHorizontal:2', 'fullWidth']}>
        <View
          variants={['bg:neutral1', 'padding:2', 'gap:1.5', 'column', 'fullWidth']}
          style={{ borderRadius: 32, zIndex: 1 }}
        >
          <View variants={['fullWidth', 'row', 'justifySpaceBetween', 'alignCenter', 'marginBottom:1']}>
            {!!hurdle?.date ? (
              <View variants={['center']}>
                <Icon debugName='' name='calendar' size={12} variants={['neutral5']} />
                <Text variants={['p3', 'color:neutral5', 'marginLeft:0.5']} text={formatHurdleDate(hurdle.date)} />
              </View>
            ) : null}

            <View style={styles.progressBar}>
              <ProgressBar {...getHurdleProgressProps(hurdle)} />
            </View>
          </View>

          <View variants={['row', 'justifyStart', 'alignCenter', 'gap:1']}>
            <TagType icon='game' />
            <Text variants={['h2']} text={`Let's Hurdle!`} />
          </View>

          <View variants={['gap:1.5', 'column']}>
            {/* <View variants={['column']}>
              {words.map((row, index) => <LetterRow key={index} row={row} />)}
            </View>
            <Button text={`Guess today's sustainability word`} debugName='play_hurdle_from_feed' onPress={handleNavigateToHurdle} /> */}

            <Text variants={['p1']} text={`Guess the today's sustainability word.`} />

            <Button text='Play now' debugName='play_hurdle_from_feed' onPress={handleNavigateToHurdle} />
          </View>
        </View>
      </View>
    </>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    progressBar: {
      maxWidth: theme.spacing.value(11.5),
      flex: 1,
    },
    letterRow: {
      gap: theme.spacing.value(1),
      marginBottom: theme.spacing.value(1),
    },
  }),
  true,
)
